import { render, staticRenderFns } from "./Party.vue?vue&type=template&id=18182422&"
import script from "./Party.vue?vue&type=script&lang=ts&"
export * from "./Party.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports